import cx from 'classnames';
import { FC, useMemo } from "react";
import styles from './index.module.scss';
import CommonImage, { ImageType } from "../CommonImage";
import { ArticalCoverEnum, IArticalCover } from "@/api/thread/list";

interface FeedPreviewProps {
  covers: IArticalCover[];
}

const LIMIT = 5;


const FeedPreview: FC<FeedPreviewProps> = ({
  covers = []
}) => {

  // 将视频前置
  const videoCovers: IArticalCover[] = [];
  const otherCovers: IArticalCover[] = [];

  covers.forEach(cover => {
    if (cover.type === ArticalCoverEnum.video) {
      videoCovers.push(cover);
    } else {
      otherCovers.push(cover);
    }
  });

  const sortedCovers = [...videoCovers, ...otherCovers];
  const displayedCovers = sortedCovers.slice(0, LIMIT);
  const renderContent = useMemo(() => {
    // 没有图片/视频
    if (!covers.length) {
      return '';
    }
    // 多图/多视频
    if (covers.length > 1) {
      return displayedCovers.map((item, index) => {
        // 当前index 为 最大展示数量，且不是最后一张图
        // const displayMoreNumber = (index === (LIMIT - 1) && covers.length > LIMIT);
        return (
          <div
            key={index}
            className={cx(styles.coverItem, item.type === ArticalCoverEnum.video ? styles.play : '')}
          >
            <CommonImage
              src={item?.medium}
              cutMode="cover"
              draggable={false}
              type={ImageType.image}
            />
            {/* {displayMoreNumber ? (
              <div className={styles.mask}><div className={styles.restNumber}>+{covers.length - LIMIT}</div></div>
            ) : (<div className={styles.overlay} />)} */}
            <div className={styles.overlay} />
          </div>
        )
      })
    }
    // 单图
    if (covers[0].type  === ArticalCoverEnum.image) {
      return (
        <div className={styles.singleImage}>
          <CommonImage
            src={covers[0].medium}
            cutMode="cover"
            draggable={false}
            type={ImageType.image}
          />
        </div>
      );
    } else { // 单视频
      return (
        <div className={cx(styles.singleImage, styles.play)}>
          <CommonImage
            src={covers[0].medium}
            cutMode="cover"
            draggable={false}
            type={ImageType.image}
          />
        </div>
      )
      // return <VideoPlayer sources={videoSources} />
    }
    
  }, [covers]);

 return (
  <div
    className={styles.feedPreviewContainer}
    style={{minHeight: covers.length > 1 ? '104px' : !covers.length ? 'auto' : '171px'}} // 单图/多图设置高度
  >
    {renderContent}
  </div>
 )
}

export default FeedPreview;
